import React from 'react'

import { Portlet, Col, Row } from '_zari/core'

import * as Formatos from './formatos'

const portletBreadcrumbs = [{ name: 'Otros Reportes' }]

const InventarioFisicoReportes = () => {
  return (
    <Portlet>
      <Portlet.Header title='Otros Reportes' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Formatos.FormatoCruceVentasKardex />
          </Col>
          <Col md={6}>
            <Formatos.ReporteUtilidad />
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col md={6}>
            <Formatos.ReporteProduccion />
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default InventarioFisicoReportes
